import React, { useState } from "react";
import "../Waves.css";
import ContactModal from "../components/modals/ContactModal";

const HomePage: React.FC = () => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <div className="home-container">
      <header className="hero-section">
        <div className="h1-cover">
          <h1>Patients just a click away.</h1>
          <p>
            We help clinics <strong>connect with patients</strong>, process
            prescriptions faster, and <strong>increase your reach</strong>.
          </p>
          <button className="get-started-button" onClick={handleOpenModal}>
            Get Started
          </button>
        </div>
      </header>

      <ContactModal isOpen={showModal} onClose={handleCloseModal} />

      {/* <div className="wave"></div>
      <div className="wave"></div>
      <div className="wave"></div> */}
    </div>
  );
};

export default HomePage;
